import Action from "./actionTypes";

export const addNotification = (message, errorType) => ({
  type: Action.ADD_NOTIFICATION,
  message,
  errorType
});



// WEBPACK FOOTER //
// ./src/actions/actions-da-muks.js